import Vue from "vue"
import VueI18n from 'vue-i18n'
import es from '../../../lang/es.json'
import pt_PT from '../../../lang/pt_PT.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: window.locale,
  fallbackLocale: 'pt_BR',
  messages: {
    es: es,
    pt_PT: pt_PT,
  },
  numberFormats: {
    'es': {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    'pt-PT': {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    'pt-BR': {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
    },
  }
});

window.i18n = i18n
